import { cn } from '@/shared/lib/utils'

interface AuthShellProps {
  title: string
  subtitle?: string
  children: React.ReactNode
  className?: string
}

/**
 * Institutional auth card — aligned with the landing identity (design §10).
 * Dark brand-glass shell, Missão Futuro logo mark in place of the legacy
 * robot mascot. Used by the auth modal surfaces and the standalone auth
 * pages.
 *
 * Title is a plain heading (not Radix DialogTitle) so the shell works both
 * inside and outside a Dialog — modal wrappers provide their own sr-only
 * DialogTitle for accessibility.
 */
export function AuthShell({ title, subtitle, children, className }: AuthShellProps) {
  return (
    <div
      className={cn(
        'flex max-h-[90dvh] w-full max-w-md flex-col rounded-3xl border border-white/10',
        'bg-brand-dark/85 text-white shadow-[0_24px_60px_-20px_rgba(0,0,0,0.7)] backdrop-blur-xl',
        className
      )}
    >
      <div className="flex flex-col items-center px-6 pt-8 text-center sm:px-8">
        <img
          src="/brand/logo-icon-white.svg"
          alt="Missão Futuro"
          width={43}
          height={48}
          loading="eager"
          decoding="async"
          className="h-12 w-auto"
        />
        <h1 className="mt-4 font-hl text-2xl text-white">{title}</h1>
        {subtitle ? (
          <p className="mt-1 text-sm text-white/60">{subtitle}</p>
        ) : null}
      </div>

      <div className="overflow-y-auto px-6 pb-8 pt-6 sm:px-8">{children}</div>
    </div>
  )
}
